import { useParams, useNavigate } from "react-router";
import RccPaymentProofDetailContent from "./DetailContent";

export default function RccPaymentProofDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <RccPaymentProofDetailContent 
        id={id} 
        onActionSuccess={() => {
            setTimeout(() => navigate("/rcc/payment-proof"), 500);
        }}
    />
  );
}
